import { createSelector } from 'reselect';

import { selectUser } from 'entities/user/selectors';
import { State } from 'reducers';
import { CampaignState } from 'entities/campaign/reducer';

import Campaign from './model';

const sortFunction = (a: Campaign, b: Campaign): number => a.title.localeCompare(b.title);
const selectCampaignState = (state: State): CampaignState => state.get('entities').campaign;

export const selectCampaigns = createSelector(selectCampaignState, selectUser, (campaigns, user) =>
  campaigns
    .filter(
      (campaign: Campaign | undefined) =>
        !!campaign &&
        (campaign.company?.id === user?.organization?.id || campaign.isSharedWithSubsidiary)
    )
    .sort(sortFunction)
);

export const selectCampaignById = createSelector(
  selectCampaignState,
  (_campaigns, campaignId) => campaignId,
  (campaigns, campaignId) => campaigns.get(campaignId)
);
